module.exports = __webpack_public_path__ + "static/media/ramazan-mobile-banner-2026.d89f0dad.jpg";